// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/mondoo_policy.actions.go

import { type Scope } from "~/hooks/useScope";
import { UPDATE_CASE } from "./action";

export function canUpdateCase(scope: Scope): boolean {
  return scope.iamActions.includes(UPDATE_CASE);
}
